export const Resources = {
  CredentialsKey: 'Accesses',
  SessionInactiveKey: 'SessionInactive',
  IsImpersonationSessionKey: 'IsImpersonationSession',
  MerchantNameHiddenKey: 'MerchantNameHidden',
};

export enum ResponseMessagesTypes {
  InvalidUsernamePassword = 'Login_Error_InvalidUsernamePassword',
}
